// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_nc-0";
export var discountCodeInput = "_nc-1";